var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", { on: { currentStore: _vm.currentStoreFunc } }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 pt-5 mb-15", attrs: { cols: "12" } },
            [
              _vm.fetchLoading === false
                ? [
                    _vm.currentGroup !== undefined
                      ? _vm._l(_vm.currentGroup, function (item, index) {
                          return _c(
                            "v-col",
                            {
                              key: item.unisCustomerCd,
                              staticClass: "ma-0 pa-0 pl-5 pr-5 mb-5",
                              staticStyle: {
                                "border-top": "1px solid #4C4C4C",
                              },
                              attrs: { cols: "12" },
                            },
                            [
                              _c("GroupStoreListItem", {
                                attrs: {
                                  item: item,
                                  authorities: _vm.authorities,
                                  visitorDataset: _vm.visitorDatasetList[index],
                                  chartOptions: _vm.chartOptionsList[index],
                                  totalCount: _vm.totalCountList[index],
                                  fetchLoading: _vm.fetchLoading,
                                  currentGroupId: _vm.currentGroupId,
                                },
                              }),
                            ],
                            1
                          )
                        })
                      : [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-10 mt-4 mb-2",
                              staticStyle: { color: "#979FB1" },
                              attrs: { cols: "12" },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                          ),
                        ],
                  ]
                : _vm._l(3, function (n) {
                    return _c(
                      "v-col",
                      {
                        key: n,
                        staticClass: "ma-0 pa-0 pl-5 pr-5 mb-5",
                        staticStyle: { "border-top": "1px solid #4C4C4C" },
                        attrs: { cols: "12" },
                      },
                      [
                        _c("v-col", {
                          staticClass: "ma-0 pa-3",
                          staticStyle: { height: "4rem" },
                          attrs: { cols: "12" },
                        }),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "3" },
                              },
                              [
                                _c("v-skeleton-loader", {
                                  attrs: {
                                    boilerplate: false,
                                    elevation: "0",
                                    dark: "",
                                    type: "image",
                                    width: "100%",
                                    height: "9rem",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pl-4",
                                attrs: { cols: "9" },
                              },
                              [
                                _c("v-skeleton-loader", {
                                  attrs: {
                                    boilerplate: false,
                                    elevation: "0",
                                    dark: "",
                                    type: "image",
                                    width: "100%",
                                    height: "9rem",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }